import { Grid } from '@mui/material';
import { styled } from '@mui/system';

export const GridWrapper = styled(Grid)(({ theme }) => ({
  background: '#fff',
  borderRadius: 20,
  padding: '1em'
}));
